/* eslint-disable no-eval */
import './styles/dicgrid.css';
import dropdown from './components/Dropdown';
import tag from './components/Tag';
import select from './components/Select';
import pagination from './components/Pagination';
import list from './components/List';
import table from './components/Table';
import data from './mixins/data';
import methods from './mixins/methods';
import util from './mixins/util';
import render from './mixins/render';
export default {
  name: 's-dicgrid',
  mixins: [data, methods, util, render],
  components: {
    'v-dropdown': dropdown,
    'sp-tag': tag,
    'sp-select': select,
    'sp-page': pagination,
    'sp-list': list,
    'sp-table': table
  },
  provide: function provide() {
    return {
      i18n: this.i18n,
      renderCell: this.renderCell,
      keyField: this.keyField,
      showField: this.showField,
      inPicked: this.inPicked,
      rtl: this.rtl
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.searchField) {
      if (typeof this.showField === 'string') {
        this.searchColumn = this.showField;
      } else if (Array.isArray(this.showField) && this.showField.length) {
        this.searchColumn = this.showField[0].data;
      }
    } else this.searchColumn = this.searchField;
    if (typeof this.requestType == "undefined" || this.requestType === 'dic') {
      if (this.appMark === '') {
        this.i18n.not_found = '未设置应用标识';
        return;
      }
      this.$store.dispatch('axiosGetRequest', { url: '/bsp-com/static/dic/' + this.appMark + '/' + this.dicName + '.js' }).then(function (res) {
        if (res.status === 200) {
          var arr = [];
          var func = { getData: eval('(' + res.data + ')') };
          arr = func.getData();
          // 判断是否存在过滤条件
          if (_this.filterField) {
            var start = _this.filterField.charAt(0);
            var end = _this.filterField.charAt(_this.filterField.length - 1);

            // 过滤条件为正则表达式
            if (start == '/' && end == '/' && eval(_this.filterField) instanceof RegExp) {
              _this.data = arr.filter(function (item) {
                return eval(_this.filterField).test(item.code);
              });
            } else {
              // 过滤条件为字符串
              var filterArr = _this.filterField.split(',');
              _this.data = arr.filter(function (item) {
                return filterArr.includes(item.code);
              });
            }
          } else {
            _this.data = arr;
          }
        } else {
          _this.i18n.not_found = '字典数据加载错误';
          _this.$store.dispatch('axiosGetRequest', { url: '/bsp-com/static/dic/bsp/' + _this.dicName + '.js' }).then(function (res) {
            if (res.status === 200) {
              var _func = { getData: eval('(' + res.data + ')') };
              _this.data = _func.getData();
            } else {
              _this.i18n.not_found = '字典数据加载错误';
            }
          });
        }
      });
    } else if (this.requestType === 'loopData') {
      // 单循环数据
      this.data = this.loopData;
    } else {
      this.$store.dispatch('authPostRequest', { url: this.path }).then(function (data) {
        if (data.success) {
          _this.data = data.rows;
        } else {
          _this.i18n.not_found = '数据加载错误';
        }
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/dicGrid.js
// module id = 4
// module chunks = 0